export interface HighlightedTextProps {
	html: string;
}

export const HighlightedText = ({ html }: HighlightedTextProps) => {
	return <span dangerouslySetInnerHTML={{ __html: html }} />;
};
